import { render, staticRenderFns } from "./TheoryList.vue?vue&type=template&id=1458a6aa&scoped=true&"
import script from "./TheoryList.vue?vue&type=script&lang=js&"
export * from "./TheoryList.vue?vue&type=script&lang=js&"
import style0 from "./TheoryList.vue?vue&type=style&index=0&id=1458a6aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458a6aa",
  null
  
)

export default component.exports